import LogoImg from "../images/LogoClear.svg";

export default function Logo() {
  return (
    <div>
      <img alt="logo" src={LogoImg}></img>
    </div>
  );
}
